module.exports = __webpack_public_path__ + "img/Delor Baumann.5e30a255.jpg";